import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';
import { isNumber } from 'util';

@Injectable()
export class ProdutoProvider {

  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into produtos(Prod_Codigo, Prod_Descricao, Prod_CodBarra, Prod_Unidade, Prod_PrecoVenda, Prod_Estoque) ' +
            'values (?, ?, ?, ?, ?, ?)';
          for (let val of data) {
            let produto = new Produto();
            produto.codigo = val.Prod_Codigo;
            produto.nome = val.Prod_Descricao;
            produto.codigobarras = val.Prod_CodBarra;
            produto.unidade = val.Prod_Unidade;
            produto.preco = val.Prod_PrecoVenda;
            produto.estoque = val.Prod_EstoqueAtual;
            let params = [produto.codigo, produto.nome, produto.codigobarras, produto.unidade, produto.preco, produto.estoque];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou produto');
            }, (err) => {
              console.log('erro:' + err);
            });

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from produtos';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getAll(codTabelaPreco = 0, search: string = null) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = "";
        if (codTabelaPreco > 0) {
          sql = 'SELECT p.Prod_Codigo, Prod_Descricao,  Prod_CodBarra, Prod_Unidade, ' +
            '       COALESCE(Tbi_Valor, Prod_PrecoVenda) AS Prod_PrecoVenda, Prod_Estoque ' +
            'FROM produtos p ' +
            '  LEFT JOIN tabelapreco_itens tbi on tbi.Prod_Codigo = p.Prod_Codigo and Tab_Codigo = ' + codTabelaPreco +
            ' WHERE 1 > 0 ';
        } else {
          sql = 'SELECT * ' +
            'FROM produtos p ' +
            'WHERE 1 > 0 ';
        }
        let data: any[] = [];

        if (search) {
          sql += ' and (';

          if (isNumber(parseInt(search))) {
            sql += ' p.Prod_Codigo = ? or ';
            data.push(parseInt(search));
          }
          sql += ' Prod_CodBarra like ? or ';
          data.push(search + '%');

          sql += ' Prod_Descricao like ? )';
          data.push('%' + search + '%');
        }
        sql += ' ORDER BY Prod_Descricao';

        return db.executeSql(sql, data)
          .then((data: any) => {
            if (data.rows.length > 0) {
              let produtos: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var produto = new Produto();
                produto.codigo = data.rows.item(i).Prod_Codigo;
                produto.nome = data.rows.item(i).Prod_Descricao;
                produto.codigobarras = data.rows.item(i).Prod_CodBarra;
                produto.unidade = data.rows.item(i).Prod_Unidade;
                produto.preco = data.rows.item(i).Prod_PrecoVenda;
                produto.estoque = data.rows.item(i).Prod_Estoque;
                produtos.push(produto);
              }
              return produtos;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public get(codProduto, codTabelaPreco = 0) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = "";
        if (codTabelaPreco > 0) {
          sql = 'SELECT p.Prod_Codigo, Prod_Descricao,  Prod_CodBarra, Prod_Unidade, ' +
            '       COALESCE(Tbi_Valor, Prod_PrecoVenda) AS Prod_PrecoVenda, Prod_Estoque ' +
            'FROM produtos p ' +
            '  LEFT JOIN tabelapreco_itens tbi on tbi.Prod_Codigo = p.Prod_Codigo and Tab_Codigo = ' + codTabelaPreco +
            ' WHERE 1 > 0 AND p.Prod_Codigo = ?';
        } else {
          sql = 'SELECT * ' +
            'FROM produtos p ' +
            'WHERE 1 > 0 AND p.Prod_Codigo = ?';
        }

        sql += ' ORDER BY Prod_Descricao';

        return db.executeSql(sql, [codProduto])
          .then((data: any) => {
            let produto = new Produto();
            if (data.rows.length > 0) {
              produto.codigo = data.rows.item(0).Prod_Codigo;
              produto.nome = data.rows.item(0).Prod_Descricao;
              produto.codigobarras = data.rows.item(0).Prod_CodBarra;
              produto.unidade = data.rows.item(0).Prod_Unidade;
              produto.preco = data.rows.item(0).Prod_PrecoVenda;
              produto.estoque = data.rows.item(0).Prod_Estoque;
            }
            return produto;
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

export class Produto {
  codigo: number;
  codigobarras: string;
  nome: string;
  unidade: string;
  preco: number;
  estoque: number;
}



// WEBPACK FOOTER //
// ./src/providers/produto/produto.ts